import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiAppLegacy, USER_PROFILE_QUERY_KEY } from '@/shared/api';

/**
 * 이메일 변경 mutation — 현재 프로필 전체를 fetch 해 email 만 교체 후 `PUT /users/me/profile` 전송(구앱 정합).
 * narrow PUT 이 타 필드를 wipe 하지 않도록 **fetch-full → modify → PUT-full**. 성공 시 프로필 무효화.
 * 후처리(토스트·시트 닫기)는 caller 가 소유(SRP). 현재 비밀번호 확인은 하지 않는다(사용자 결정).
 */
export function useChangeEmailMutation() {
  const api = useApiAppLegacy();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (email) => {
      // profile PUT 은 profile 노드만(account 미포함) — 현재 프로필 전체 + email 교체로 타 필드 보존.
      const current = await api.user.getProfile();
      await api.user.updateProfile({
        profile: { ...(current.profile ?? {}), email },
      });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: USER_PROFILE_QUERY_KEY });
    },
  });
}
